var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑复制模板",
            visible: _vm.visible,
            width: "710px",
            center: "",
            "before-close": _vm.cancel,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.copyTplSourceData, function (item) {
              return _c(
                "div",
                { key: item.key, staticClass: "y-ml-20 config-box y-pb-15" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "config-title y-pd-5 y-p-r y-fl-16 y-fs-14 y-fc-333",
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "y-ml-5",
                      model: {
                        value: _vm.form[item.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, item.key, $$v)
                        },
                        expression: "form[item.key]",
                      },
                    },
                    _vm._l(item.value, function (childItem) {
                      return _c(
                        "el-checkbox",
                        {
                          key: childItem.key,
                          attrs: { label: childItem.key, name: item.key },
                        },
                        [_vm._v(_vm._s(childItem.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sure } },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }